import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { showFlyout } from '../../../Dashboard/actions';
import { getFlyout } from '../../../Dashboard/selectors';
import { upDirection, downDirection } from '../../../Common/constants';
import { useAction } from '../../../Common/hooks';
import { visitFlyout } from '../../constants';
import { setCurrentSelectedVisit, setGridSortCriteria } from '../../actions';
import {
  getVisitsGridSortCriteria,
  selectVisitGridIsLoading,
  selectVisitsReports,
} from '../../selectors';

const useVisitsList = () => {
  const [activeRow, setActiveRow] = useState(undefined);
  const flyout = useSelector(getFlyout);
  const { sortByColumn, sortDirection } = useSelector(getVisitsGridSortCriteria);
  const visitsRows = useSelector(selectVisitsReports);
  const isLoading = useSelector(selectVisitGridIsLoading);
  const dispatchShowFlyout = useAction(showFlyout);
  const dispatchSelectedVisit = useAction(setCurrentSelectedVisit);
  const dispatchGridSortCriteria = useAction(setGridSortCriteria);

  useEffect(() => {
    if (flyout.show === false) {
      setActiveRow(null);
    }
  }, [flyout]);

  const handleRowClick = row => {
    setActiveRow(undefined);
    dispatchShowFlyout(visitFlyout);
    dispatchSelectedVisit(row);
  };

  const handleColumnClick = ({ headerName, direction }) => {
    dispatchGridSortCriteria({
      sortByColumn: headerName,
      sortDirection: direction === upDirection ? downDirection : upDirection,
    });
  };

  return {
    handleRowClick,
    activeRow,
    handleColumnClick,
    sortByColumn,
    sortDirection,
    visitsRows,
    isLoading,
  };
};

export default useVisitsList;
